import React from 'react';
import SEO from '../components/SEO';
import Reveal from '../components/Reveal';
import { faqSchema, breadcrumbSchema } from '../utils/schema';
import content from '../content/faq.json';

const FAQ = () => (
  <main className="textPage">
    <SEO
      content={content}
      jsonLd={[
        faqSchema(content.faqs),
        breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'FAQ', path: '/faq' },
        ]),
      ]}
    />
    <article>
      <header className="textPage__head">
        <Reveal as="h1" className="label textPage__label">
          FAQ
        </Reveal>
        <Reveal as="p" className="textPage__lede" delay={0.05}>
          {content.lede}
        </Reveal>
      </header>
      <Reveal className="faq" delay={0.1}>
        {content.faqs.map((item, i) => (
          <details key={item.question} className="faq__item" open={i === 0}>
            <summary className="faq__q">
              <span>{item.question}</span>
              <span className="faq__icon" aria-hidden="true" />
            </summary>
            <p className="faq__a">{item.answer}</p>
          </details>
        ))}
      </Reveal>
    </article>
  </main>
);

export default FAQ;
